import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react';
import MainMenu from "../Layout/MainMenu";
import Footer from "../Home/Footer";
import axios from "axios";
import { HmacSHA224 } from "crypto-js";
import { easing, event } from "jquery";
//import moment from "moment";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { subYears, addYears, format, parse } from 'date-fns';
import { FaAngleDown } from 'react-icons/fa';

function CSI_UIC() {
    const [isDivVisible, setDivVisible] = useState(false);
    const [ArrivalCity, setArrivalCity] = useState('');
    const apiUrl = process.env.REACT_APP_API_URL;

   
    return (

        <section>
             
            
            <div className="plan-80 pt-xs-20 " >
                <section className="coverage">
                
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                   

                        <div className="container">
                        
    <div className="justify-content-center">


<div  className="row justify-content-center" style={{paddingBottom:'50px'}}>
    <div className="col-md-5 " >
            <div>
            <img
                                            src="../images/uicinsur.png"
                                            alt="travel insurance"
                                            style={{ display: 'block', margin: 'auto' ,width: '-webkit-fill-available', borderRadius:'1rem'}}
                                        />
            </div>
        </div>
          
          
        <div className="col-md-7 " >
            <div>
            {/* <p style={{fontWeight:'bold',color:'#000'}}>Explore the World with Confidence</p> */}
                <h2 className="text-left" style={{ fontWeight: 'bold' }}>Reliable Travel Coverage with United Insurance Company of Pakistan (UIC)</h2>
                <blockquote>
                The United Insurance Company of Pakistan Limited (UIC), rated AA+ by PACRA, is a trusted name in the travel insurance industry in Pakistan. Offering a wide range of online travel insurance plans, UIC ensures seamless protection for travelers heading to Schengen states, worldwide destinations, and students traveling abroad. Their comprehensive policies cover medical emergencies, trip cancellations, lost or delayed baggage, personal accidents, and more, providing financial security and peace of mind throughout your journey.
                <br />
                Whether you're planning a business trip, a family vacation, or a study-abroad program, UIC’s affordable travel insurance plans cater to all types of travelers. With the convenience of instant online travel insurance booking in Pakistan, travelers can quickly obtain coverage from anywhere. If you’re looking for the best travel insurance in Pakistan, UIC offers flexible and cost-effective travel insurance plans with worldwide assistance, ensuring you are protected no matter where you go.
                </blockquote>
            </div>
            
        </div>
        </div>


        <div className="row justify-content-center" style={{paddingBottom:'50px'}}>
    <div className="col-md-7 order-2 order-md-1" >
        <div>
           {/* <p style={{fontWeight:'bold',color:'#000'}}>Welcome Your Guests with Assurance </p> */}
            <h2 className="text-left" style={{ fontWeight: 'bold' }}>Comprehensive Travel Insurance with Crescent Star Insurance Limited (CSI)</h2>
            <blockquote>
            Established in 1957, Crescent Star Insurance Limited (CSI) has built a strong reputation in Pakistan’s general insurance industry. Registered with the Securities & Exchange Commission of Pakistan (SECP) and a member of the Insurance Association of Pakistan, CSI provides a diverse range of insurance solutions, including motor insurance, health insurance, fire & marine insurance, and online travel insurance from Pakistan.
            <br />
            CSI’s travel insurance plans are specifically designed for tourists, business travelers, students, and families seeking hassle-free protection. Their coverage includes medical emergencies, accidental death, trip delays, lost luggage, and emergency repatriation, making them an excellent choice for international travel insurance in Pakistan. Whether you need Schengen travel insurance, worldwide travel insurance, or group travel insurance, CSI offers customized and budget-friendly policies.
            </blockquote>
        </div>
        
    </div>
    <div className="col-md-5 order-1 order-md-2" >
        <div>
            <img
                src="../images/csiinsur.png"
                alt="travel insurance"
                style={{ display: 'block', margin: 'auto' ,width: '-webkit-fill-available', borderRadius:'1rem'}}
            />
        </div>
    </div>
</div>

  </div>
  </div>
  </div>
  </div>
  </section>
  </div>
  

        

                   

                
            

            
  

        
        </section>
    );

}



export default CSI_UIC;